import { api, ApiResponse, PaginatedResponse } from './api';

export interface Notification {
  id: string;
  user_id: string;
  workspace_id: string;
  item_id?: string;
  type: string;
  title: string;
  message: string;
  data?: Record<string, any>;
  is_read: boolean;
  read_at?: string;
  created_at: string;
  updated_at: string;
}

export const notificationApi = {
  getAll: async (workspaceId?: string, unreadOnly?: boolean): Promise<Notification[]> => {
    const params = new URLSearchParams({ per_page: '50' });
    if (workspaceId) params.append('workspace_id', workspaceId);
    if (unreadOnly) params.append('unread_only', 'true');
    
    const response = await api.get<ApiResponse<PaginatedResponse<Notification>>>(`/api/v1/notifications?${params.toString()}`);
    return response.data.data?.data || [];
  },

  getUnreadCount: async (): Promise<number> => {
    const response = await api.get<ApiResponse<{ count: number }>>('/api/v1/notifications/unread-count');
    return Number(response.data.data?.count) || 0;
  },

  markAsRead: async (id: string): Promise<Notification> => {
    const response = await api.post<ApiResponse<Notification>>(`/api/v1/notifications/${id}/mark-read`);
    return response.data.data!;
  },

  markAllAsRead: async (workspaceId?: string): Promise<void> => {
    await api.post('/api/v1/notifications/mark-all-read', { workspace_id: workspaceId });
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/api/v1/notifications/${id}`);
  },
};
